export const DATE_SHORTCUT_KEYS = {
  dateShortcutKey: 'dateShortcut',
  shortcutStepKey: 'shortcutStep',
};
